<div class="wrapper">
  <div class="table-container">
    <qm-filters [range]="true" [typeFilters]="typeFilters" (filtersChanged)="filtersChanged($event)"></qm-filters>
    <div *qmLoading="loading;config:loadingConfig" class="d-flex flex-column tile-container">
      <div class="vivo-list">
        <ul class="timeline" *ngIf="events && events.length > 0">
          <li *ngFor="
                let event of events
                  | qmOrderBy : '-timestamp'
                  | slice: (currentPage-1) * pageSize : (currentPage-1) * pageSize + pageSize"
                (mouseenter)="setActive(event)"
                (mouseleave)="setActive(null)"
                class="timeline-inverted">
            <ng-container *ngIf="event.id.startsWith('vivo_')">
              <a [attr.data-btnId]="getElementId('openInVivo')" class="timeline-badge"
                 [ngClass]="getBadgeClass(event.status)"
                 [href]="getVivoLink()" target="_blank">
                <svg style="height: 1.3em; width: 1.3em; margin-top: -0.3em;" *ngIf="event.id.startsWith('vivo_') &&
                event.taskType !== 'newComment'">
                  <use xlink:href="#vivo"></use>
                </svg>
                <svg style="height: 1.3em; width: 1.3em; margin-top: -0.3em;" *ngIf="event.id.startsWith('vivo_') &&
                event.taskType ===  'newComment'">
                  <use xlink:href="#vivo-comment"></use>
                </svg>
                <svg style="height: 1.3em; width: 1.3em; margin-top: -0.3em;" *ngIf="event.id.startsWith('alarm_')">
                  <use xlink:href="#alarm"></use>
                </svg>
              </a>
            </ng-container>
            <ng-container *ngIf="!event.id.startsWith('vivo_')">
              <a [attr.data-btnId]="getElementId('openDetails')" class="timeline-badge"
                 [ngClass]="getBadgeClass(event.status)"
                 (click)="openDetails(event.id)">
                <svg style="height: 1.3em; width: 1.3em; margin-top: -0.3em;" *ngIf="event.id.startsWith('vivo_')">
                  <use xlink:href="#vivo"></use>
                </svg>
                <svg style="height: 1.3em; width: 1.3em; margin-top: -0.3em;" *ngIf="event.id.startsWith('alarm_')">
                  <use xlink:href="#alarm"></use>
                </svg>
                <svg style="height: 1.3em; width: 1.3em; margin-top: -0.3em;"
                     *ngIf="event.id.startsWith('notification_')">
                  <use xlink:href="#note"></use>
                </svg>
              </a>
            </ng-container>
            <div class="timeline-panel">
              <div class="timeline-body d-flex flex-column">
                <div class="meta d-flex justify-content-between flex-wrap">
                  <div class="user">
                    <span>{{event.user}}</span>
                  </div>
                  <div class="date d-flex justify-content-end align-items-center">
                    <span>
                      {{isActive(event) ? (event.timestamp | qmDateFormat:'HH:mm:ss dd.MM.yyyy') : (event.timestamp | qmDateDistance)}}
                    </span>
                  </div>
                </div>
                <div class="content" *ngIf="event.translate && event.translate.length > 0">
                  {{event.text | translate | qmReplace: event.translate}}
                </div>
                <div class="content" *ngIf="!event.translate">
                  {{event.text}}
                </div>
              </div>
              <div class="asset-name" *ngIf="event.assetName">
                <span>{{event.assetName}}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div style="width: 100%; margin-top: 0.2em;" class="d-flex justify-content-center">
        <ngb-pagination
          [(page)]="currentPage"
          [pageSize]="pageSize"
          [maxSize]="pageSize"
          [collectionSize]="events.length">
        </ngb-pagination>
      </div>

    </div>
  </div>
</div>

<i class="far fa-user" data-fa-transform="shrink-4" data-fa-symbol="user"></i>
<i class="far fa-pencil" data-fa-transform="shrink-4" data-fa-symbol="edit"></i>
<i class="far fa-check-square" data-fa-symbol="vivo"></i>
<i class="far fa-exclamation" data-fa-symbol="alarm"></i>
<i class="far fa-sticky-note" data-fa-symbol="note"></i>
<i class="far fa-comment-dots" data-fa-symbol="vivo-comment"></i>
